

import React from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'semantic-ui-react';
import { searchApi } from '../../api/searchApi';
import { useCommonContext } from '../../contexts/common';
import styles from "./GlobalSearch.module.css";
import { useSelector } from 'react-redux';
const initialState = {
    loading: false,
    results: [],
    value: '',
};

const search_reducer = (state, action) => {
    switch (action.type) {
        case 'CLEAN_QUERY':
            return initialState;
        case 'START_SEARCH':
            return { ...state, loading: true, value: action.query };
        case 'FINISH_SEARCH':
            return { ...state, loading: false, results: action.results };
        case 'UPDATE_SELECTION':
            return { ...state, value: action.selection };

        default:
            throw new Error();
    }
};

const GlobalSearch = ({ onResultChanged }) => {
    const { dm_coso_id } = useSelector(x => x.coSo);
    const { nam_hoc } = useSelector(x => x.namHoc)
    const composeTitle = (data) => {
        return (
            data.ho_ten
        );
    };
    const { canAccessTo, translate } = useCommonContext();

    const [state, dispatch] = React.useReducer(search_reducer, initialState);
    const { loading, results, value } = state;
    const timeoutRef = React.useRef();
    
    const handleSearchChange = React.useCallback(
        (e, data) => {
            clearTimeout(timeoutRef.current);
            dispatch({ type: 'START_SEARCH', query: data.value });

            timeoutRef.current = setTimeout(() => {
                if (data.value.length === 0) {
                    dispatch({ type: 'CLEAN_QUERY' });
                    return;
                }
                (async () => {
                    const res = await searchApi.search({
                        key: data.value,
                        dm_coso_id,
                        nam_hoc
                    })
                    if (res.is_success) {

                        let result = [];
                        if (res.data.ts_hocsinhs) {
                            res.data.ts_hocsinhs.forEach(ts_hocsinh => {
                                result.push({
                                    title: `${ts_hocsinh.ho_ten} - ${ts_hocsinh.ma_hs}`,
                                    ts_hocsinh
                                })
                            });
                        }
                        if (res.data.ts_phuhuynhs) {
                            res.data.ts_phuhuynhs.forEach(ts_phuhuynh => {
                                result.push({
                                    title: `${ts_phuhuynh.ho_ten} - ${ts_phuhuynh.dien_thoai}`,
                                    ts_phuhuynh
                                })
                            });
                        }
                        if (res.data.ts_hoso_surveys) {
                            res.data.ts_hoso_surveys.forEach(ts_hoso_survey => {
                                result.push({
                                    title: `${ts_hoso_survey.ho_ten}- ${ts_hoso_survey.dien_thoai_lien_he}`,
                                    ts_hoso_survey
                                })
                            });
                        }

                        dispatch({
                            type: 'FINISH_SEARCH',
                            results: result
                        });
                    } else {
                        return state;
                    }
                })();
            }, 500);
        },
        [dm_coso_id, nam_hoc]
    );
    React.useEffect(() => {
        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, []);

    React.useEffect(() => {
        dispatch({ type: 'CLEAN_QUERY' });
        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const resultRenderer = (data) => {

        if (data.ts_hocsinh) {
            return (
                <React.Fragment>
                    <Link to={`/hoc-sinh/${data.ts_hocsinh.id}`} style={{
                        color: "#3caa62"
                    }}>
                        <div className={styles.item_container}>
                            <div className={styles.info_container}>
                                <div className={styles.item_title}>{data.ts_hocsinh.ho_ten}</div>
                                <div className={styles.item_description}>{data.ts_hocsinh.ma_hs}</div>
                            </div>
                            <div>
                                <span className={styles.item_tag_hocsinh}>Học sinh</span>
                            </div>
                        </div>
                    </Link>
                </React.Fragment>
            );
        }
        if (data.ts_phuhuynh) {
            return (
                <React.Fragment>
                    <Link to={`/phu-huynh/${data.ts_phuhuynh.id}`} style={{
                        color: "#3caa62"
                    }}>
                        <div className={styles.item_container}>
                            <div className={styles.info_container}>
                                <div className={styles.item_title}>{data.ts_phuhuynh.ho_ten}</div>
                                <div className={styles.item_description}>{data.ts_phuhuynh.dien_thoai}</div>
                            </div>
                            <div>
                                <span className={styles.item_tag_phuhuynh}>Phụ huynh</span>
                            </div>
                        </div>
                    </Link>
                </React.Fragment>
            );
        }
        if (data.ts_hoso_survey) {
            const phuHuynhLienHe = data.ts_hoso_survey.ts_phuhuynhs.find(x => x.dien_thoai == data.ts_hoso_survey.dien_thoai_lien_he);
            const phuHuynhKhac = data.ts_hoso_survey.ts_phuhuynhs.find(x => x.dien_thoai != data.ts_hoso_survey.dien_thoai_lien_he);
            const phuHuynhLinkId = phuHuynhLienHe ? phuHuynhLienHe.id : (phuHuynhKhac ? phuHuynhKhac.id : 0);
            return (
                <React.Fragment>
                    <Link to={`/phu-huynh/${phuHuynhLinkId}`} style={{
                        color: "#3caa62"
                    }}>
                        <div className={styles.item_container}>
                            <div className={styles.info_container}>
                                <div className={styles.item_title}>{data.ts_hoso_survey.ho_ten}</div>
                                <div className={styles.item_description}>{data.ts_hoso_survey.dien_thoai_lien_he}</div>
                                <div className={styles.item_description}>{data.ts_hoso_survey.nguoi_lien_he}</div>
                            </div>
                            <div>
                                <span className={styles.item_tag_hoso}>Data học sinh</span>
                            </div>
                        </div>
                    </Link>
                </React.Fragment>
            );
        }

    };
    return (
        <Search
            loading={loading}
            onResultSelect={(e, data) => {
                dispatch({ type: 'UPDATE_SELECTION', selection: data.result.title });
                if (onResultChanged) {
                    onResultChanged(data.result);
                }

            }}
            onSearchChange={handleSearchChange}
            results={results}
            resultRenderer={resultRenderer}
            value={value}
            input={{
                icon: 'search',
                placeholder: translate('Tìm kiếm học sinh, phụ huynh'),
            }}
            fluid
            className={styles.search}
        ></Search>
    );
};
export default GlobalSearch